import { render, staticRenderFns } from "./apkVersionMange.vue?vue&type=template&id=04b3f8ae&scoped=true"
import script from "./apkVersionMange.vue?vue&type=script&lang=js"
export * from "./apkVersionMange.vue?vue&type=script&lang=js"
import style0 from "./apkVersionMange.vue?vue&type=style&index=0&id=04b3f8ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b3f8ae",
  null
  
)

export default component.exports